import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

const { color, border, mediaQuery } = baseVariables;

export const StyledEventProfileContainer = styled.div`
  background-color: ${color.neutral10};
`;

export const StyledEventProfile = styled.div`
  padding: ${toRem(24)} 0;
`;

export const StyledEventProfileForm = styled.div`
  padding: ${toRem(40)} ${toRem(16)};
  border: ${toRem(1)} ${border.borderStyleDefault} ${color.neutral20};
  border-radius: ${toRem(12)};
  background-color: ${color.base20};
  box-shadow: 0 0 ${toRem(8)} 0 rgba(0, 0, 0, 0.07);

  @media ${mediaQuery.md} {
    padding: ${toRem(40)} ${toRem(60)};
  }

  @media ${mediaQuery.lg} {
    padding: ${toRem(40)} ${toRem(94)};
  }
`;

export const StyledDivider = styled.div`
  margin: ${toRem(40)} 0;
  border-top: ${toRem(1)} solid ${color.neutral30};
`;

export const StyledCtaContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: ${toRem(32)} 0;

  .continue-cta {
    width: 90%;
  }

  @media ${mediaQuery.md} {
    justify-content: flex-end;

    .continue-cta {
      width: auto;
    }
  }
`;
